<template>
    <div class="post-content entry-content" style="margin: 20px 0;text-align: center;">
        <!-- <section style="white-space:normal;font-size:14px;">
        <span class="v3brush" style="box-sizing:border-box !important;color:#3E3E3E;font-family:微软雅黑;font-size:14px;line-height:21px;max-width:100%;word-wrap:break-word !important">
            <span class="v3brush" style="box-sizing:border-box !important;color:inherit;max-width:100%;word-wrap:break-word !important">
                <span class="v3brush" style="border:1.95px solid #599BAB;box-shadow:rgba(0,0,0,0.34902) 2px 2px 4px 1px inset;color:inherit;display:inline-block;font-size:14px;line-height:1em;max-width:100%;min-width:160px;padding:10px 20px;box-sizing:border-box !important;word-wrap:break-word !important;">公众号：优启运维</span>
            </span>
        </span>
        <span class="v3brush" style="border:1.95px solid #599BAB;color:#FFFFFF;display:inline-block;font-family:微软雅黑;font-size:14px;line-height:1em;max-width:100%;padding:10px;box-sizing:border-box !important;word-wrap:break-word !important;background-color:#599BAB;" @click="goFollow">加关注</span>
        </section> -->
        <!-- <img src="/res/QR2_wechat.png" width="150" height="150"> -->
        <img src="/res_ext/QR2_wechat.png" width="150" height="150">
        <p style="font-size:16px;color:#424242;font-weight: bold;margin-bottom: 10px;">长按识别 关注公众号</p>
        <p style="font-size:16px;color:#424242;font-weight: bold;">关注后才能收到推送信息</p>
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data: () => ({
  }),
  methods: {
    goFollow() {
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzEwNzk3NA==#wechat_redirect';
    }
  },
  created() {
  },
  mounted() {
  },
  activated() {
  },
  deactivated() {
  }
}

</script>

<style scoped>

</style>
